<template>
  <div class="signed" v-if="ok">
    <div class="columns is-centered">
      <section class="content-box column is-three-quarters">
        <h1>Klart</h1>
        <p>Vi har nu mottagit din underskrift.</p>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const apiUrl = 'https://shares-subscription-forms-api.reguity.com';
export default {
  name: 'signed',
  data: () => ({
    ok: String(window.document.referrer).indexOf('login.grandid.com') != -1
  }),
  mounted: async function() {
  },
  components: {
    //HelloWorld
  }
}
</script>
